<div class="master-container border-radius-30">
  <div class="info-container">
    <h5>
      {{ "train.confirm-stepper-container.seat-selection.title" | translate }}
      {{
      (firstTrain
      ? "train.confirm-stepper-container.seat-selection.outward"
      : "train.confirm-stepper-container.seat-selection.return"
      ) | translate
      }}
    </h5>
    <div class="seat-guide">
      <div class="seat-guide-container">
        <div class="seat" style="grid-area: avilable">
          <img src="assets/img/svg/seat-available.svg" alt="available" />
          <p>{{ "my-bookeds.flight.available" | translate }}</p>
        </div>
        <div class="seat" style="grid-area: selected">
          <img src="assets/img/svg/seat-selected.svg" alt="selected" />
          <p>{{ "my-bookeds.flight.selected" | translate }}</p>
        </div>
        <div class="seat" style="grid-area: seat_taken">
          <img src="assets/img/svg/seat-occupied.svg" alt="seat_taken" />
          <p>{{ "my-bookeds.flight.noAvailable" | translate }}</p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="section.seats && section.seats.length > 0">
    <div class="seatmap">
      <div class="carriages-container">
        <div *ngFor="let carriage of section.seats[0]?.carriages">
          <button class="carriage-number" (click)="viewCarriage(carriage)" [ngClass]="{'selected-carriage': showedCarriage.name === carriage.name}">{{  getCarriageName(carriage.name)}}</button>
        </div>
      </div>
      <div class="showed-carriage" *ngIf="showedCarriage">
        <div class="scrollable-table-container">
          <div class="deck" *ngFor="let deck of showedCarriage.decks">
            <div class="row" *ngFor="let _ of [].constructor(deck.rows); let i = index">
              <div class="cell" *ngFor="let _ of [].constructor(deck.columns); let j = index">
                <ng-container *ngIf="getSeat(deck, i, j) as seat; else aisle">
                  <div class="seat" *ngIf="getSeatContent(i, j, deck) && getSeatContent(i, j, deck).availability === 'available' && getSeatContent(i, j, deck).type === 'Seat'" (click)="selectSeat(i, j, deck)">
                    <img [src]="isSelected(i, j, deck) ? 'assets/img/svg/seat-selected.svg' : 'assets/img/svg/seat-available.svg'" style="width: 2rem;" [ngClass]="{'front-direction': getSeatContent(i, j, deck).direction === 270 }" />
                    <div class="custom-seat">{{ getSeatContent(i, j, deck).position }}</div>
                  </div>
                  <div class="seat" *ngIf="getSeatContent(i, j, deck) && getSeatContent(i, j, deck).availability === 'available' && getSeatContent(i, j, deck).type === 'WheelchairSpace'" (click)="selectSeat(i, j, deck)">
                    <img [src]="isSelected(i, j, deck) ? 'assets/img/svg/wheelchair-black.svg' : 'assets/img/svg/wheelchair-available.svg'" style="width: 2rem;" [ngClass]="{'front-direction': getSeatContent(i, j, deck).direction === 270 }" />
                    <div class="custom-seat">{{ getSeatContent(i, j, deck).position }}</div>
                  </div>
                  <div class="seat" *ngIf="getSeatContent(i, j, deck) && getSeatContent(i, j, deck).availability === 'unavailable' && getSeatContent(i, j, deck).type === 'Seat'" (click)="selectSeat(i, j, deck)">
                    <img [src]="'assets/img/svg/seat-occupied.svg'" style="width: 2rem;" [ngClass]="{'front-direction': getSeatContent(i, j, deck).direction === 270 }" />
                    <div class="custom-seat">{{ getSeatContent(i, j, deck).position }}</div>
                  </div>
                  <div class="seat" *ngIf="getSeatContent(i, j, deck) && getSeatContent(i, j, deck).availability === 'unavailable' && getSeatContent(i, j, deck).type === 'WheelchairSpace'" (click)="selectSeat(i, j, deck)">
                    <img [src]="'assets/img/svg/wheelchair-occupied.svg'" style="width: 2rem;" [ngClass]="{'front-direction': getSeatContent(i, j, deck).direction === 270 }" />
                    <div class="custom-seat">{{ getSeatContent(i, j, deck).position }}</div>
                  </div>
                  <!-- <div *ngIf="!getSeatContent(i, j, deck) || getSeatContent(i, j, deck).availability === 'unavailable'">
                    <img src="assets/img/svg/seat-occupied.svg" style="width: 2rem;" />
                    <div class="custom-seat">{{getSeatContent(i, j, deck)?.position ? getSeatContent(i, j, deck).position : 'XX'}}  {{ getSeatContent(i, j, deck)?.type }}</div>
                  </div> -->
                  <div *ngIf="getSeatContent(i, j, deck) && getSeatContent(i, j, deck).type === 'Table'">
                    <div class="table"></div>
                  </div>
                </ng-container>
                <ng-template #aisle>
                  <div class="aisle"></div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="fixed-footer">
          <p style="font-weight: 600;">{{section.origin}} - {{section.destination}}</p>
          <ng-container *ngIf="showSeatText(way)">
            <div *ngFor="let seat of getSectionSeats(way)">
              <span>{{getSeatText(seat)}}</span>
            </div>
          </ng-container>
          <p style="font-weight: 600; font-size: large;">{{getTotalSeats()}} €</p>
          <button (click)="confirmSeats()" class="custom-btn">
            {{ "flight.result-flight.select-seat.confirm-seat-selection" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>